import React from 'react';
import ShopProvider from './src/context/shopContext';
export const wrapRootElement = ({ element }) => {
  return <ShopProvider>{element}</ShopProvider>;
};
